import MicroModal from 'micromodal'

import { lockScroll, unlockScroll } from './scrollLock'

/**
 * Video modal (MicroModal). Thumbnails are triggers marked
 * `data-micromodal-trigger="modal-video"` carrying `data-id` (the YouTube id)
 * and `data-title`. Opening injects an autoplaying iframe into the modal's
 * `.js-video-modal-frame`; closing removes it, which stops playback (and frees
 * the player) rather than just hiding it.
 *
 * Scroll is locked while open with the shared Lenis-aware helper, so it matches
 * the lightbox and doesn't shift the layout.
 *
 * @param {import('lenis').default|null} [lenis] - smooth-scroll instance to pause
 */
export function initVideoModal(lenis = null) {
  const frame = document.querySelector('.js-video-modal-frame')
  if (!frame) return

  MicroModal.init({
    awaitCloseAnimation: true,
    disableScroll: false, // we lock scroll ourselves (Lenis-aware, no jump)
    onShow: (modal, trigger) => {
      lockScroll(lenis)

      const id = trigger?.dataset.id
      if (!id) return
      const iframe = document.createElement('iframe')
      iframe.className = 'absolute inset-0 size-full'
      iframe.title = trigger.dataset.title || 'Video'
      iframe.allow =
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
      iframe.allowFullscreen = true
      iframe.src = `https://www.youtube-nocookie.com/embed/${id}?rel=0&autoplay=1`
      frame.replaceChildren(iframe)
    },
    onClose: () => {
      unlockScroll(lenis)
      // Dropping the iframe stops the audio/video immediately.
      frame.replaceChildren()
    },
  })
}
